import { ref } from "vue";

const visible = ref(false);
const state = ref(null);
const loading = ref(false);

export function useConfirmAction() {
  const confirmAction = ({
    message,
    header,
    danger = false,
    items = null,
    accept,
  }) => {
    state.value = { message, header, danger, items, accept };
    visible.value = true;
  };

  const handleAccept = async () => {
    if (!state.value?.accept) return;
    loading.value = true;
    try {
      await state.value.accept();
    } finally {
      loading.value = false;
      visible.value = false;
    }
  };

  const handleCancel = () => {
    if (loading.value) return;
    visible.value = false;
  };

  return { confirmAction, visible, state, loading, handleAccept, handleCancel };
}
